import { useLocation } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { fetchSummaryStockReportPdfLink } from '@apis/performance';
import { ApiRequestError } from '@app-types/api';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * Click-triggered stock report link fetch.
 * Reads ticker/mkt from the iframe URL and sends auth via the summary API client.
 */
export const useSummaryStockReportPdfLink = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);

  return useMutation<string>({
    mutationKey: ['summary', 'stock-report-pdf-link', ticker, mkt],
    mutationFn: () => {
      if (!ticker || !mkt || !getAccessToken()) {
        throw new ApiRequestError('Stock report PDF link request is missing required context.');
      }

      return fetchSummaryStockReportPdfLink({ ticker, mkt });
    },
  });
};
